import Swiper from 'swiper';
import { Navigation, Pagination } from 'swiper/modules';

const swiper = new Swiper('.swiper', {
	speed: 400,
	spaceBetween: 0,
	slidesPerView: 1,
	loop: true,
  	modules: [Navigation, Pagination],

	pagination: {
		el: '.swiper-pagination',
		type: 'bullets',
		clickable: true,
	},

	navigation: {
		nextEl: '.swiper-button-next',
		prevEl: '.swiper-button-prev',
	},
});


/*
const INTERVAL_MILLISECOND = 7000

const sliders = document.querySelectorAll(".slider")

for(const slider of sliders) {

	const previousButton = slider.querySelector(".slider__navigation__previous")
	const nextButton = slider.querySelector(".slider__navigation__next")
	const bullets = slider.querySelectorAll(".slider__navigation__bullets__bullet")
	const images = slider.querySelectorAll(".slider__images__image")

	let currentIndex = 0
	let interval

	function startInterval() {
		interval = setInterval(() => next(), INTERVAL_MILLISECOND)
	}

	function restartInterval() {
		clearInterval(interval)
		startInterval()
	}

	function setImage(index) {
		const activeBullet = bullets[currentIndex]
		const activeImage = images[currentIndex]
		activeBullet.classList.remove("active")
		activeImage.classList.remove("active")
		currentIndex = index
		const nextBullet = bullets[currentIndex]
		const nextImage = images[currentIndex]
		nextBullet.classList.add("active")
		nextImage.classList.add("active")
	}

	function previous() {
		if(currentIndex - 1 >= 0) {
			setImage(currentIndex - 1)
		} else {
			setImage(bullets.length - 1)
		}
	}

	function next() {
		if(currentIndex + 1 > bullets.length - 1) {
			setImage(0)
		} else {
			setImage(currentIndex + 1)
		}
	}

	previousButton.addEventListener("click", () => {
		restartInterval()
		previous()
	})

	nextButton.addEventListener("click", () => {
		restartInterval()
		next()
	})

	for(const [index, bullet] of bullets.entries()) {
		bullet.addEventListener("click", () => setImage(index))
	}

	startInterval()
}
*/